import { memo } from "react";
import OwnerMilkrecordingSelect from "../../components/multiforms/OwnerMilkrecordingSelect.js";

const AnimalMilkRecordingMetrics = () => {
    return (
        <OwnerMilkrecordingSelect type={"MilkRecordingMetrics"} />
    )
}

export default memo(AnimalMilkRecordingMetrics);